var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.campaigns),function(value,campaign){return _c('div',{key:campaign,staticClass:"tracking-campaign"},[_c('VText',{attrs:{"variant":"h5","component":"h3"}},[_vm._v(_vm._s(campaign))]),_vm._v(" "),_c('TrackingCampaign',{attrs:{"data":value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }